module.exports = __webpack_public_path__ + "img/item6.2f74910e.png";